import { v4 as uuid } from 'uuid';
import './StockOrderSkeletonLoader.scss';

/**
 * Componente que muestra un skeleton loader para las tarjetas de órdenes de stock
 * Mantiene las mismas dimensiones y estructura que StockOrderCard
 */
const StockOrderSkeletonLoader = () => {
  const generateSingleCard = () => (
    <div key={uuid()} className="stockOrderCardSkeleton">
      <section className="headerSection">
        <div className="providerNameAndFlag">
          <div className="flagSkeleton" />
          <div className="warehouseNameSkeleton" />
        </div>
        <div className="orderNumberSkeleton" />
      </section>

      <section className="bodySection">
        <div className="leftData">
          <div className="estimatedDateSkeleton" />
          <div className="providerNameSkeleton" />
        </div>

        <div className="rightData">
          <div className="creationDateSkeleton" />
          <div className="costDataSkeleton" />
          <div className="shipmentsCountSkeleton" />
        </div>
      </section>
    </div>
  );

  const generateColumnCards = () => {
    return Array(5).fill(null).map(() => generateSingleCard());
  };

  return <>{generateColumnCards()}</>;
};

export default StockOrderSkeletonLoader;
